import React from 'react'
import PropTypes from 'prop-types'
import { IonIcon } from 'controls'
import { iadProvitionalColors } from 'theme/colors'

import { ModalConfirm } from 'components/Modals'

import styles from './styles'

const SimpleSuccessModal = ({
  title,
  children,
  imageIcon,
  onConfirm,
  onCancel,
  isOpen,
  ...rest
}) => {
  return (
    <ModalConfirm
      showRejectButton={false}
      isOpen={isOpen}
      onConfirm={onConfirm || onCancel}
      onCancel={onCancel}
      {...rest}
    >
      <IonIcon
        size="large"
        style={{ color: iadProvitionalColors.primary }}
        icon="md-checkmark-circle-outline"
      />
      <h3 className="title">{title}</h3>
      {children}
      <style jsx>{styles}</style>
    </ModalConfirm>
  )
}

SimpleSuccessModal.defaultProps = {
  title: 'Mensaje enviado con éxito',
}

SimpleSuccessModal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  imageIcon: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default SimpleSuccessModal
